const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "vp_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const imageUrl = (id) => (id ? `${API}/images/${id}` : null);

async function request(path, { method = "GET", body, isForm } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (!isForm && body) headers["Content-Type"] = "application/json";

  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: isForm ? body : body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    clearToken();
    throw new Error("unauthorized");
  }
  if (!res.ok) {
    let detail = "Une erreur est survenue.";
    try {
      const d = await res.json();
      if (typeof d.detail === "string") detail = d.detail;
    } catch (e) {
      /* ignore */
    }
    throw new Error(detail);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const adminApi = {
  login: (password) => request("/auth/login", { method: "POST", body: { password } }),
  me: () => request("/auth/me"),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return request("/admin/images", { method: "POST", body: fd, isForm: true });
  },
  listProjects: () => request("/admin/projects"),
  createProject: (p) => request("/admin/projects", { method: "POST", body: p }),
  updateProject: (id, p) => request(`/admin/projects/${id}`, { method: "PUT", body: p }),
  deleteProject: (id) => request(`/admin/projects/${id}`, { method: "DELETE" }),
  duplicateProject: (id) => request(`/admin/projects/${id}/duplicate`, { method: "POST" }),
  reorderProjects: (ids) => request("/admin/projects/reorder", { method: "POST", body: { ids } }),
  getAnnouncement: () => request("/admin/announcement"),
  saveAnnouncement: (a) => request("/admin/announcement", { method: "PUT", body: a }),
  listDevis: () => request("/admin/devis"),
  updateDevis: (id, status) => request(`/admin/devis/${id}`, { method: "PATCH", body: { status } }),
  deleteDevis: (id) => request(`/admin/devis/${id}`, { method: "DELETE" }),
  listRdv: () => request("/admin/rendez-vous"),
  updateRdv: (id, status) => request(`/admin/rendez-vous/${id}`, { method: "PATCH", body: { status } }),
  deleteRdv: (id) => request(`/admin/rendez-vous/${id}`, { method: "DELETE" }),
};
